import React from 'react';

import Axis from './D3Axis';

import { formatAxisDate } from '../d3-helpers';

const TimeRangeAxis = ({
  chartId,
  clipPathId,
  xAxisLabel,
  yAxisLabel,
  margins,
  height,
  width,
  xScale,
  yScale,
  xTickValues,
  yTickValues,
  labelRotation = -15,
  useTickWrapping = false,
  xTickFormat = formatAxisDate,
  yTickFormat = val => val,
  xTicks,
  yTicks,
}) => {
  const xSettings = {
    id: `${chartId}-x-axis`,
    scale: xScale,
    orient: 'bottom',
    transform: `translate(0, ${height})`,
    ticks: xTicks,
    tickFormat: xTickFormat,
    tickValues: xTickValues,
    clipPath: `url(#${clipPathId})`,
    axisLabel: xAxisLabel,
    height,
    width,
    margins,
    useTickWrapping,
    labelRotation,
  };
  const ySettings = {
    id: `${chartId}-y-axis`,
    scale: yScale,
    orient: 'left',
    transform: 'translate(0, 0)',
    ticks: yTicks,
    tickFormat: yTickFormat,
    axisLabel: yAxisLabel,
    tickValues: yTickValues,
    height,
    width,
    margins,
  };

  return (
    <g className="axis-group">
      <Axis {...xSettings} />
      <Axis {...ySettings} />
    </g>
  );
};

export default TimeRangeAxis;
